import { createSelector } from 'reselect';

import homeSearchFiltersSelector from 'selectors/homeSearchFiltersSelector';
import requestIsActiveSelectorFactory from '../factories/requestIsActiveSelectorFactory';
import ActionTypes from '../../constants/ActionTypes';
import unitOptionsSelector from '../unitOptionsSelector';

const unitsSelector = (state) => state.data.units;

const homePageSelector = createSelector(
  requestIsActiveSelectorFactory(ActionTypes.API.UNITS_GET_REQUEST),
  unitOptionsSelector,
  unitsSelector,
  homeSearchFiltersSelector,
  (
    isFetchingUnits,
    unitOptions,
    units,
    urlSearchFilters
  ) => ({
    isFetchingUnits,
    filters: urlSearchFilters,
    unitOptions,
    units,
  })
);

export default homePageSelector;



/** WEBPACK FOOTER **
 ** ./app/selectors/containers/homePageSelector.js
 **/